import { Banner } from "shared/components/Banner";

export const WaitlistLinkWarning = () => (
  <Banner
    variant="warning"
    textTheme="base"
    borders="none"
    title="This lead's unit is on the waitlist."
    body="They can't book a tour or apply until it's available, so this link won't work for them yet."
  />
);
